import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Ve a https://console.firebase.google.com/
// Crea un proyecto nuevo
// Ve a Configuración del Proyecto > SDK y copia tu configuración aquí

const firebaseConfig = {
  apiKey: "AIzaSyC9dKqt5UENxm57oZN5kASfrWrcKDY7Z2E",
  authDomain: "next-global-media.firebaseapp.com",
  projectId: "next-global-media",
  storageBucket:  "next-global-media.firebasestorage.app",
  messagingSenderId: "300913005365",
  appId: "1:300913005365:web:47d6d9ed40b43837a8f27c",
  measurementId: "G-2HL296TB0F"
};

const missingConfigKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingConfigKeys.length > 0) {
  console.error(
    'FirebaseConfig: faltan las siguientes variables de entorno:',
    missingConfigKeys.join(', '),
    'Revisa tu archivo .env y reinicia el servidor.'
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

export default app;
